// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/authentication_log(.:format)`
 * - Path helper: `user_settings_authentication_log_path`
 * - URL helper: `user_settings_authentication_log_url`
 * - controller#action: `user_settings/user_settings#authentication_log`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsAuthenticationLogPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsAuthenticationLogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"authentication_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsAuthenticationLogPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"authentication_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsAuthenticationLogPath(organizationPath, ...routeArgs);
  }

  return _userSettingsAuthenticationLogPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/applications(.:format)`
 * - Path helper: `user_settings_applications_path`
 * - URL helper: `user_settings_applications_url`
 * - controller#action: `oauth/applications#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsApplicationsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsApplicationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsApplicationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsApplicationsPath(organizationPath, ...routeArgs);
  }

  return _userSettingsApplicationsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/active_sessions(.:format)`
 * - Path helper: `user_settings_active_sessions_path`
 * - URL helper: `user_settings_active_sessions_url`
 * - controller#action: `user_settings/active_sessions#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsActiveSessionsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsActiveSessionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"active_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsActiveSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"active_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsActiveSessionsPath(organizationPath, ...routeArgs);
  }

  return _userSettingsActiveSessionsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/active_sessions/:id(.:format)`
 * - Path helper: `user_settings_active_session_path`
 * - URL helper: `user_settings_active_session_url`
 * - controller#action: `user_settings/active_sessions#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsActiveSessionPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsActiveSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userSettingsActiveSessionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"active_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsActiveSessionPath(organizationPath, ...routeArgs);
  }

  return _userSettingsActiveSessionPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/profile(.:format)`
 * - Path helper: `user_settings_profile_path`
 * - URL helper: `user_settings_profile_url`
 * - controller#action: `user_settings/profiles#show`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsProfilePath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsProfilePath(organizationPath, ...routeArgs);
  }

  return _userSettingsProfilePath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/identities/new(.:format)`
 * - Path helper: `new_user_settings_identities_path`
 * - URL helper: `new_user_settings_identities_url`
 * - controller#action: `user_settings/identities#new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newUserSettingsIdentitiesPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserSettingsIdentitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newUserSettingsIdentitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"identities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationUserSettingsIdentitiesPath(organizationPath, ...routeArgs);
  }

  return _newUserSettingsIdentitiesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/identities(.:format)`
 * - Path helper: `user_settings_identities_path`
 * - URL helper: `user_settings_identities_url`
 * - controller#action: `user_settings/identities#create`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsIdentitiesPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsIdentitiesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsIdentitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"identities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsIdentitiesPath(organizationPath, ...routeArgs);
  }

  return _userSettingsIdentitiesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/password/reset(.:format)`
 * - Path helper: `reset_user_settings_password_path`
 * - URL helper: `reset_user_settings_password_url`
 * - controller#action: `user_settings/passwords#reset`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const resetUserSettingsPasswordPath = /*#__PURE__*/ (...args) => {
  const _resetOrganizationUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _resetUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _resetOrganizationUserSettingsPasswordPath(organizationPath, ...routeArgs);
  }

  return _resetUserSettingsPasswordPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/password/new(.:format)`
 * - Path helper: `new_user_settings_password_path`
 * - URL helper: `new_user_settings_password_url`
 * - controller#action: `user_settings/passwords#new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newUserSettingsPasswordPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationUserSettingsPasswordPath(organizationPath, ...routeArgs);
  }

  return _newUserSettingsPasswordPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/password/edit(.:format)`
 * - Path helper: `edit_user_settings_password_path`
 * - URL helper: `edit_user_settings_password_url`
 * - controller#action: `user_settings/passwords#edit`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const editUserSettingsPasswordPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _editOrganizationUserSettingsPasswordPath(organizationPath, ...routeArgs);
  }

  return _editUserSettingsPasswordPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/password(.:format)`
 * - Path helper: `user_settings_password_path`
 * - URL helper: `user_settings_password_url`
 * - controller#action: `user_settings/passwords#update`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsPasswordPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsPasswordPath(organizationPath, ...routeArgs);
  }

  return _userSettingsPasswordPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/personal_access_tokens/toggle_dpop(.:format)`
 * - Path helper: `toggle_dpop_user_settings_personal_access_tokens_path`
 * - URL helper: `toggle_dpop_user_settings_personal_access_tokens_url`
 * - controller#action: `user_settings/personal_access_tokens#toggle_dpop`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const toggleDpopUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _toggleDpopOrganizationUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"toggle_dpop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _toggleDpopUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"toggle_dpop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _toggleDpopOrganizationUserSettingsPersonalAccessTokensPath(organizationPath, ...routeArgs);
  }

  return _toggleDpopUserSettingsPersonalAccessTokensPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/personal_access_tokens/granular/new(.:format)`
 * - Path helper: `granular_new_user_settings_personal_access_tokens_path`
 * - URL helper: `granular_new_user_settings_personal_access_tokens_url`
 * - controller#action: `user_settings/personal_access_tokens#granular_new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const granularNewUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _granularNewOrganizationUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"granular"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _granularNewUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"granular"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _granularNewOrganizationUserSettingsPersonalAccessTokensPath(organizationPath, ...routeArgs);
  }

  return _granularNewUserSettingsPersonalAccessTokensPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/personal_access_tokens/legacy/new(.:format)`
 * - Path helper: `legacy_new_user_settings_personal_access_tokens_path`
 * - URL helper: `legacy_new_user_settings_personal_access_tokens_url`
 * - controller#action: `user_settings/personal_access_tokens#legacy_new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const legacyNewUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _legacyNewOrganizationUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"legacy"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _legacyNewUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[2,[7,"/"],[2,[6,"legacy"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _legacyNewOrganizationUserSettingsPersonalAccessTokensPath(organizationPath, ...routeArgs);
  }

  return _legacyNewUserSettingsPersonalAccessTokensPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/personal_access_tokens(.:format)`
 * - Path helper: `user_settings_personal_access_tokens_path`
 * - URL helper: `user_settings_personal_access_tokens_url`
 * - controller#action: `user_settings/personal_access_tokens#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsPersonalAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsPersonalAccessTokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"personal_access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsPersonalAccessTokensPath(organizationPath, ...routeArgs);
  }

  return _userSettingsPersonalAccessTokensPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/gpg_keys/:id/revoke(.:format)`
 * - Path helper: `revoke_user_settings_gpg_key_path`
 * - URL helper: `revoke_user_settings_gpg_key_url`
 * - controller#action: `user_settings/gpg_keys#revoke`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const revokeUserSettingsGpgKeyPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationUserSettingsGpgKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _revokeUserSettingsGpgKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _revokeOrganizationUserSettingsGpgKeyPath(organizationPath, ...routeArgs);
  }

  return _revokeUserSettingsGpgKeyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/gpg_keys(.:format)`
 * - Path helper: `user_settings_gpg_keys_path`
 * - URL helper: `user_settings_gpg_keys_url`
 * - controller#action: `user_settings/gpg_keys#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsGpgKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsGpgKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsGpgKeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsGpgKeysPath(organizationPath, ...routeArgs);
  }

  return _userSettingsGpgKeysPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/gpg_keys/:id(.:format)`
 * - Path helper: `user_settings_gpg_key_path`
 * - URL helper: `user_settings_gpg_key_url`
 * - controller#action: `user_settings/gpg_keys#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsGpgKeyPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsGpgKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userSettingsGpgKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"gpg_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsGpgKeyPath(organizationPath, ...routeArgs);
  }

  return _userSettingsGpgKeyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/ssh_keys/:id/revoke(.:format)`
 * - Path helper: `revoke_user_settings_ssh_key_path`
 * - URL helper: `revoke_user_settings_ssh_key_url`
 * - controller#action: `user_settings/ssh_keys#revoke`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const revokeUserSettingsSshKeyPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationUserSettingsSshKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _revokeUserSettingsSshKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _revokeOrganizationUserSettingsSshKeyPath(organizationPath, ...routeArgs);
  }

  return _revokeUserSettingsSshKeyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/ssh_keys(.:format)`
 * - Path helper: `user_settings_ssh_keys_path`
 * - URL helper: `user_settings_ssh_keys_url`
 * - controller#action: `user_settings/ssh_keys#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsSshKeysPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsSshKeysPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsSshKeysPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsSshKeysPath(organizationPath, ...routeArgs);
  }

  return _userSettingsSshKeysPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/ssh_keys/:id(.:format)`
 * - Path helper: `user_settings_ssh_key_path`
 * - URL helper: `user_settings_ssh_key_url`
 * - controller#action: `user_settings/ssh_keys#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsSshKeyPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsSshKeyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userSettingsSshKeyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"ssh_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsSshKeyPath(organizationPath, ...routeArgs);
  }

  return _userSettingsSshKeyPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/integration_accounts/deny(.:format)`
 * - Path helper: `deny_user_settings_integration_accounts_path`
 * - URL helper: `deny_user_settings_integration_accounts_url`
 * - controller#action: `profiles/chat_names#deny`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const denyUserSettingsIntegrationAccountsPath = /*#__PURE__*/ (...args) => {
  const _denyOrganizationUserSettingsIntegrationAccountsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _denyUserSettingsIntegrationAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[6,"deny"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _denyOrganizationUserSettingsIntegrationAccountsPath(organizationPath, ...routeArgs);
  }

  return _denyUserSettingsIntegrationAccountsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/integration_accounts(.:format)`
 * - Path helper: `user_settings_integration_accounts_path`
 * - URL helper: `user_settings_integration_accounts_url`
 * - controller#action: `profiles/chat_names#index`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsIntegrationAccountsPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsIntegrationAccountsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _userSettingsIntegrationAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsIntegrationAccountsPath(organizationPath, ...routeArgs);
  }

  return _userSettingsIntegrationAccountsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/integration_accounts/new(.:format)`
 * - Path helper: `new_user_settings_integration_account_path`
 * - URL helper: `new_user_settings_integration_account_url`
 * - controller#action: `profiles/chat_names#new`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const newUserSettingsIntegrationAccountPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationUserSettingsIntegrationAccountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _newUserSettingsIntegrationAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _newOrganizationUserSettingsIntegrationAccountPath(organizationPath, ...routeArgs);
  }

  return _newUserSettingsIntegrationAccountPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/user_settings/integration_accounts/:id(.:format)`
 * - Path helper: `user_settings_integration_account_path`
 * - URL helper: `user_settings_integration_account_url`
 * - controller#action: `profiles/chat_names#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const userSettingsIntegrationAccountPath = /*#__PURE__*/ (...args) => {
  const _organizationUserSettingsIntegrationAccountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _userSettingsIntegrationAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"integration_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationUserSettingsIntegrationAccountPath(organizationPath, ...routeArgs);
  }

  return _userSettingsIntegrationAccountPath(...routeArgs);
};

